import { Injectable } from '@angular/core';
import { ComponentLocationStrategy } from './component-location-strategy';

@Injectable()
export class DokulinkLocationStrategy extends ComponentLocationStrategy {
  constructor() {
    super();
  }

  componentId(): string {
    return 'DOKULINK_MODAL';
  }
}
